import { DeleteSharp, EditSharp } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  deleteV2VRejectReason,
  getV2VRejectReason,
  insertV2VRejectReason,
  updateV2VRejectReason
} from "src/api/commonapi";
import Page from "src/components/Page";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function V2VRejectReason() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [addEditModal, setAddEditModal] = useState(false);
  const [v2vRejectReasonData, setV2VRejectReasonData] = useState({
    v2v_reject_reason: ""
  });
  const [tableData, setTableData] = useState([]);
  const toggleAddEditModal = () => setAddEditModal(!addEditModal);
  const [isLoading, setIsLoading] = useState(false);

  const resetFormData = () => {
    setV2VRejectReasonData({
      v2v_reject_reason: ""
    });
  };
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [response, setresponse] = useState(0);

  const handleSubmit = async (newData = undefined) => {
    if (newData != undefined ? newData : v2vRejectReasonData.v2v_r_id != undefined) {
      // update
      if ((newData != undefined ? newData : v2vRejectReasonData).v2v_reject_reason != "") {
        let fnData = new FormData();
        fnData.append(
          "v2v_r_id",
          newData != undefined ? newData.v2v_r_id : v2vRejectReasonData.v2v_r_id
        );
        fnData.append(
          "v2v_reject_reason",
          newData != undefined ? newData.v2v_reject_reason : v2vRejectReasonData.v2v_reject_reason
        );

        setIsLoading(true);
        let resp = await updateV2VRejectReason(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          newData == undefined && toggleAddEditModal();
          getMeetingFeedbackForData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    } else {
      // Insert
      if (v2vRejectReasonData.v2v_reject_reason != "") {
        let fnData = new FormData();
        fnData.append("v2v_reject_reason", v2vRejectReasonData.v2v_reject_reason);
        setIsLoading(true);
        let resp = await insertV2VRejectReason(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          getMeetingFeedbackForData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    }
  };
  const deleteV2VRejectReasons = async (v2v_r_id) => {
    const resp = await deleteV2VRejectReason(v2v_r_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };
  const getMeetingFeedbackForData = async () => {
    setIsLoading(true);
    let res = await getV2VRejectReason();
    setIsLoading(false);
    setTableData(res);
  };
  useEffect(() => {
    getMeetingFeedbackForData();
  }, [response]);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row?.v2v_r_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.v2v_reject_reason,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      selector: (row) => (
        <>
          <Tooltip title="Edit">
            <IconButton
              onClick={() => {
                setV2VRejectReasonData({
                  v2v_reject_reason: row.v2v_reject_reason,
                  v2v_r_id: row.v2v_r_id
                });
                toggleAddEditModal();
              }}
            >
              <EditSharp color="warning" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete">
            <IconButton
              onClick={() => {
                setDvisible({ mval: true, id: row.v2v_r_id });
              }}
            >
              <DeleteSharp color="error" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <>
      <Deletemodal
        visible={dvisible}
        setVisible={setDvisible}
        deletefunc={deleteV2VRejectReasons}
      />

      <Page title="LVB V2V Reject Reasons | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  V2V Reject Reasons
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => (toggleAddEditModal(), resetFormData())}
                style={{ marginBottom: "15px", float: "right" }}
                variant="contained"
              >
                Add V2V Reject Reasons
              </Button>
            </Grid>
          </Grid>

          <Modal
            open={addEditModal}
            onClose={() => (toggleAddEditModal(), resetFormData())}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                Add V2V Reject Reason
              </Typography>
              <hr />
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Grid container>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="V2V Reject Reason"
                      name="v2v_reject_reason"
                      placeholder="Enter V2V Reject Reason"
                      onChange={(e) => {
                        setV2VRejectReasonData({
                          ...v2vRejectReasonData,
                          v2v_reject_reason: e.target.value
                        });
                      }}
                      value={v2vRejectReasonData?.v2v_reject_reason}
                    />
                  </Grid>
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => (toggleAddEditModal(), resetFormData())}
                      style={{ marginTop: "15px", marginRight: "15px" }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginTop: "15px" }}
                      onClick={() => handleSubmit()}
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Modal>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
